module.exports = __webpack_public_path__ + "img/lens-150-minus-04.154b44b3.png";